import { TimeWindow } from '@cemex-core/cmx-api';
import {
  OneClickTimeWindowsActions,
  OneClickTimeWindowsActionTypes,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-time-windows.actions';

export interface OneClickTimeWindowsState {
  loading: boolean;
  timeWindowsAvailable: TimeWindow[];
  selected: TimeWindow;
}

export const initialState: OneClickTimeWindowsState = {
  loading: false,
  timeWindowsAvailable: [],
  selected: null,
};

export function reducer(state = initialState, action: OneClickTimeWindowsActions): OneClickTimeWindowsState {
  switch (action.type) {
    case OneClickTimeWindowsActionTypes.LOAD_TIME_WINDOWS: {
      return {
        ...state,
        loading: true,
      } as OneClickTimeWindowsState;
    }
    case OneClickTimeWindowsActionTypes.LOAD_TIME_WINDOWS_COMPLETE: {
      return {
        ...state,
        loading: false,
        timeWindowsAvailable: [...action.payload],
      } as OneClickTimeWindowsState;
    }
    case OneClickTimeWindowsActionTypes.SELECT_TIME_WINDOWS: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickTimeWindowsState;
    }
    case OneClickTimeWindowsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
